<template>
  <div class="home-container">
    <div class="home-content">
      <el-tabs v-model="activeName" @tab-click="handleClick">
        <el-tab-pane
          :label="item.name"
          :name="item.id"
          v-for="(item, ind) in tabList"
          :key="ind"
          ></el-tab-pane
        >
      </el-tabs>
      <nightPlay v-if="activeName == 0"></nightPlay>
      <nightRoute v-if="activeName == 1"></nightRoute>
      <nightClass v-if="activeName == 2"></nightClass>
      <stabdard v-if="activeName == 3"></stabdard>
    </div>
  </div>
</template>

<script>
import stabdard from "./components/standard"
import nightClass from "./components/nightClass"
import nightRoute from "./components/nightRoute"
import nightPlay from "./components/nightPlay"
export default {
    components:{
        stabdard,
        nightClass,
        nightRoute,
        nightPlay
    },
  data() {
    return {
      tabList: [
        {
          id: "0",
          name: "巡更计划管理",
        },
        {
          id: "1",
          name: "巡更路线管理",
        },
        {
          id: "2",
          name: "巡更点管理",
        },
        {
          id: "3",
          name: "巡更标准管理",
        },
      ],
      activeName: "0",
    };
  },
  mounted() {},
  methods: {
    handleClick(tab, event) {
      this.activeName = tab.index
    },
  },
};
</script>

<style>
.home-container {
  padding: 10px;
  padding-top: 5px;
}
.home-content {
  padding: 10px;
  border-radius: 5px;
  background: #fff;
}
</style>